import React, {useState, useRef} from 'react';
import './Contact.css';
import $ from 'jquery';


const Contact = () => {

  const handleSubmit = (event) => {
    event.preventDefault();

    $.ajax({
      url: 'https://api.apispreadsheets.com/data/zc9TZOTjJevRE6qd/',
      type: 'post',
      data: $('#myForm').serializeArray(),
      success: function (response) {
        console.log(response);
        alert('Form Data Submitted!');
      },
      error: function (xhr, status, error) {
        console.log(xhr.responseText); 
        alert('There was an error :(');
      },
    });
  };

  return (
    <div className='contact'>
        <div className='leftSide'></div>
        <div className='rightSide'>
            <h1>Contact Us</h1>

            <form id='myForm' onSubmit={handleSubmit}>
                <label>Full Name: </label>
                <input name='name' placeholder='Enter full name...' type='text' required/>
                <label>Email: </label>
                <input name='email' placeholder='Enter email...' type='email' required/>
                <label>Message: </label>
                <textarea name='message' rows='6' placeholder='Enter message...' required></textarea>
                <button type='submit'>Send Message</button>
            </form>
        </div>
    </div>
  )
}

export default Contact